module.exports = __webpack_public_path__ + "img/zjdxbg.757fea9a.png";